
































































































































































































import { Component, Vue, Prop } from 'vue-property-decorator';
import LinkButton from '@/components/LinkButton.vue';
import { FeaturedList, Movie } from '@/store/types';
import FlTranslatableTextarea from '@/components/FlTranslatableTextarea.vue';
import NoticeModal from '@/components/NoticeModal.vue';
import { UserMixin, PreviewMixin } from '@/Mixin';
import FlMovieImage from '@/components/FlMovieImage.vue';
@Component({
  components: {
    LinkButton,
    FlTranslatableTextarea,
    NoticeModal,
    FlMovieImage,
  },
  mixins: [UserMixin, PreviewMixin],
})
export default class FeatureListEdit extends Vue {
  private uuid?: string = null;
  private featuredList?: FeaturedList = null;
  private currentScreener: Object = null;
  private copiedIndex: number = -1;
  private stateMessage: string = 'loading...';
  mounted() {
    this.uuid = this.$route.params.feature_id;

    if (this.uuid != null) {
      this.getList();
    }
  }
  getList() {
    this.stateMessage = 'loading...';
    this.axios
      .get(`/featured_list/${this.uuid}`)
      .then((result: any) => {
        if (result.status === 200) {
          this.$set(this, 'featuredList', result.data.data);
          if (result.data.data.length === 0) {
            this.stateMessage = 'empty list';
          }
        }
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  copyScreenerPassword(movie: Movie) {
    this.copiedIndex = this.featuredList.movies.indexOf(movie);
    const element = document.createElement('textarea');
    element.value = movie.screener_password;
    document.body.appendChild(element);
    element.select();
    document.execCommand('copy');
    document.body.removeChild(element);

    setTimeout(() => {
      this.copiedIndex = -1;
    }, 3000);
  }

  showDetail(movie: Movie) {
    window.open(`/movies/detail/${movie.uuid}`);
  }

  getDetailUrl(movie: Movie) {
    return `/movies/detail/${movie.uuid}`;
  }

  playScreener(movie: Movie) {
    this.currentScreener = movie;
  }

  addToCart(movie: Movie) {
    if (!(this as any).isLoggedIn) {
      this.$modal.show('requestLogin');
      return;
    }

    this.$store
      .dispatch('carts/createCart', { movieId: movie.uuid })
      .then((result: any) => {
        this.$modal.show('addedSingle');
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  addAllToCart() {
    if (!(this as any).isLoggedIn) {
      this.$modal.show('requestLogin');
      return;
    }

    let tasks = this.featuredList.movies.map((movie) => {
      return this.$store.dispatch('carts/createCart', { movieId: movie.uuid });
    });

    Promise.all(tasks)
      .then((results: any) => {
        this.$modal.show('addedAll');
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  addRecommendedToCart() {
    if (!(this as any).isLoggedIn) {
      this.$modal.show('requestLogin');
      return;
    }

    let tasks = this.featuredList.movies
      .filter((movie: any) => {
        return movie.recommend;
      })
      .map((movie) => {
        return this.$store.dispatch('carts/createCart', { movieId: movie.uuid });
      });
    Promise.all(tasks)
      .then((results: any) => {
        this.$modal.show('addedRecommend');
      })
      .catch((error: any) => {
        console.log(error);
      });
  }

  showLoginWithForward() {
    this.$store.commit('loginModalState/showLoginModal');
    this.$store.dispatch('users/setNextPage', { nextPage: this.$route.path });
  }

  movieImage(movie: Movie) {
    if (!movie.featured_images || movie.featured_images.length == 0) {
      return '';
    } else {
      return (movie.featured_images[0] as any).file.url;
    }
  }

}
